export default __webpack_public_path__ + "static/arcanum_expansion-294247e3724aa7bd8fb4689a8e0d985d.mp4";